/**
 * Sdílené třídy formulářových prvků.
 *
 * Vzniklo z auditu stylování: focus ring byl byte-identicky zopakovaný ve čtyřech
 * komponentách (Input, Textarea, Select, MenuSelect) a podbarvení povinného pole ve
 * třech — změna vizuálního kontraktu tak vyžadovala editovat všechna místa.
 *
 * Záměrně jako TS konstanty, ne `@utility`: `INVALID_RING` v Input/Textarea přepisuje
 * border i shadow ve focus stavu. Kdyby byl základní ring utilitou, rozhodovalo by
 * o vítězi pořadí uvnitř utilities vrstvy (které Tailwind řadí sám), ne pořadí
 * argumentů v `cn()`. Takhle je přebíjení předvídatelné.
 *
 * Pozn.: záměrně `focus:`, ne `focus-visible:` — sjednocení s Buttonem (který používá
 * `focus-visible:`) by změnilo chování u `<select>` a tlačítkových triggerů a žádný
 * test ani vizuální baseline focus stavy nepokrývá. Vyřešit vědomě, ne mimochodem.
 */

/** Focus ring formulářového prvku — modrý rámeček + shadow, bez nativního outline. */
export const FIELD_FOCUS_RING =
  'focus:outline-none focus:border-phx-primary focus:shadow-phx-focus';

/** Podbarvení povinného pole; při editaci ustoupí, aby nerušilo čtení hodnoty. */
export const FIELD_REQUIRED_BG = 'bg-phx-required-tint focus:bg-phx-surface';
